import assign from 'object-assign';
import StorageAPI from 'src/core/utils/StorageAPI';
import * as constants from 'vd-constants';
/* UTILS */
import { AppDispatcher } from 'dispatcher';
import get from 'lodash/get';
import AuthService from 'models/AuthService';
import { getDefaultTimeFormat } from 'utils/LocaleUtil';
import { AuthStore } from './AuthStore';
import { BaseStore } from './BaseStore';

const SHOW_EXPERIMENTAL_FEATURES = 'SHOW_EXPERIMENTAL_FEATURES';
const SHOW_ALL_EVENT_THUMBNAILS = 'SHOW_ALL_EVENT_THUMBNAILS';
const PLAY_LIST_SOURCE = 'PLAY_LIST_SOURCE';

let _impl = null;
let showExperimentalFeatures = StorageAPI.getLocally(SHOW_EXPERIMENTAL_FEATURES);
let showAllEventThumbnails = StorageAPI.getLocally(SHOW_ALL_EVENT_THUMBNAILS);
let playListSourceIndex = parseInt(StorageAPI.getLocally(PLAY_LIST_SOURCE)) || 0;

class RealUserImpl {
  constructor({ token, data = {} }) {
    this.data = data;
    this.token = token;
  }

  get(key) {
    if (!key || typeof key !== 'string') {
      return this.data;
    }
    return get(this.data, key);
  }

  sync(key, value) {
    this.date = { ...this.data, [key]: value };
  }
}

const PreferenceStore = assign({}, BaseStore, {
  getAll() {
    if (_impl) return _impl.get();

    return undefined;
  },

  getOne(key) {
    if (_impl) {
      return _impl.get(key);
    }
    return undefined;
  },

  /** @deprecated use useUserPreferences()[0].locale instead. */
  getLocale() {
    return this.getOne('locale');
  },

  shouldShowExperimentalFeatures: function () {
    return showExperimentalFeatures;
  },

  shouldShowAllEventThumbnails: function () {
    return showAllEventThumbnails;
  },

  getSelectedPlayListSource: function () {
    return constants.VIDEO_SOURCE_OPTIONS[playListSourceIndex];
  },

  /** @deprecated use useTimeFormat() instead. */
  getTimeFormat() {
    // Fallback to default time format of the locale if not set
    return this.getOne('timeFormat') || getDefaultTimeFormat();
  },

  /** @deprecated use useUserPreferences()[0].show360DewarpToggle instead. */
  show360DewarpToggle() {
    return this.getOne('show360DewarpToggle') || false;
  },
});

PreferenceStore.dispatchToken = AppDispatcher.register((action) => {
  switch (action.type) {
    case constants.USER_LOGGED_IN:
      if (action.token) {
        AppDispatcher.waitFor([AuthStore.dispatchToken]);
        _impl = AuthService.isImpersonating
          ? new RealUserImpl({ data: action.chUserPreferences, shouldMigrate: false })
          : new RealUserImpl({ token: action.token, data: action.chUserPreferences });
        PreferenceStore.emitChange();
      }
      break;

    case constants.SYNC_PREFERENCES:
    case constants.SET_TIME_FORMAT:
    case constants.SET_DEFAULT_TO_HD:
    case constants.UPDATE_LOCALE:
    case constants.SET_WIDGET_AUTO_REFRESH:
    case constants.SET_SHOW_EVENT_PROGRESS_IN_VIDEO_PLAYER:
      if (_impl) {
        _impl.sync(action.key, action.payload);
        PreferenceStore.emitChange();
      }
      break;

    case constants.SET_SHOW_EXPERIMENTAL_FEATURES:
      showExperimentalFeatures = action.payload;
      StorageAPI.storeLocally(SHOW_EXPERIMENTAL_FEATURES, action.payload);
      PreferenceStore.emitChange();
      break;

    case constants.SET_SHOW_ALL_EVENT_THUMBNAILS:
      showAllEventThumbnails = action.payload;
      StorageAPI.storeLocally(SHOW_ALL_EVENT_THUMBNAILS, action.payload);
      PreferenceStore.emitChange();
      break;

    case constants.SET_PLAY_LIST_SOURCE:
      playListSourceIndex = parseInt(action.payload);
      StorageAPI.storeLocally(PLAY_LIST_SOURCE, action.payload);
      PreferenceStore.emitChange();
      break;

    case constants.SET_EVENT_LIST_LAYOUT_TYPE:
      StorageAPI.storeLocally(constants.EVENT_LIST_LAYOUT_TYPE, action.payload);
      PreferenceStore.emitChange();
      break;

    case constants.FETCH_PREFERENCES:
      PreferenceStore.emitChange();
      break;
  }
});

export default PreferenceStore;
